import { useMemo } from 'react'
import { useQueries } from '@tanstack/react-query'
import { ExtendedUnitModel, getUnitString } from '../helpers/units'
import { IUnitModel } from '../interfaces/models/units.interfaces'
import { societyQueries } from '../api/societies'
import { entranceQueries } from '../api/society-entrances'
import { getIsSamf } from '../state/models/society'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'
import { ISocietyEntranceModel } from '../interfaces/models/society-entrance.interfaces'

export const unitString = (
  units: IUnitModel[],
  societies: ISocietiesModel[],
  entrances: ISocietyEntranceModel[],
  managementMode?: boolean
): string => {
  return units
    .map((_unit) => {
      const society = societies.find((_society) => _society._id === _unit._id)
      const entrance =
        _unit.entranceId &&
        entrances.find((_entrance) => _entrance._id === _unit.entranceId)
      const isSamf = getIsSamf(society)
      return getUnitString(
        { ..._unit, entrance } as ExtendedUnitModel,
        isSamf,
        managementMode
      )
    })
    .join(', ')
}

export const useUnitsString = (
  units: IUnitModel[],
  managementMode?: boolean
): string => {
  const { data: societies } = useQueries({
    queries: units.map((unit) => {
      return societyQueries.getSociety(unit.societyId)
    }),
    combine: (queries) => {
      return {
        data: queries.flatMap((query) => query.data || []),
        isLoading: queries.some((query) => query.isLoading),
      }
    },
  })

  const { data: entrances } = useQueries({
    queries: societies.map((society) => {
      return entranceQueries.getEntrancesPerSociety(society._id)
    }),
    combine: (queries) => {
      return {
        data: queries.flatMap((query) => query.data || []),
        isLoading: queries.some((query) => query.isLoading),
      }
    },
  })

  const unitsString = useMemo(
    () => unitString(units, societies, entrances, managementMode),
    [managementMode, units, entrances, societies]
  )

  return unitsString
}
